"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoneyWithCurrencyBadge = void 0;
var react_1 = __importDefault(require("react"));
/** This component is only really necessary because of our weird font that is not vertically centered. */
var MoneyWithCurrencyBadge = function (_a) {
    var currency = _a.currency, className = _a.className, children = _a.children;
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement("span", { className: 'bg-gray text-white font-size-12 font-medium padding-horizontal-1 rounded-md', style: { paddingTop: 3 } }, currency),
        "\u00A0",
        react_1.default.createElement("div", { style: { paddingTop: 3 } }, children)));
};
exports.MoneyWithCurrencyBadge = MoneyWithCurrencyBadge;
